import { useConfigContext } from '@fe-core';

export const useSessionThumbnail = ({
  session,
  size,
}: {
  session?: { uuid: string; version: number };
  size?: number;
}) => {
  const { config } = useConfigContext();
  if (!session) {
    return null;
  }

  if (!config.apiUrls?.apiweb) {
    throw new Error('Missing API URL');
  }

  let url = `${config.apiUrls.apiweb}image/session/${session.uuid}?v=${session.version}&w=t`;
  if (size) {
    url = `${url}&size=${size}`;
  }

  return url;
};

export const useBundleThumbnail = ({
  bundle,
}: {
  bundle: { uuid: string; version: number };
}) => {
  const { config } = useConfigContext();
  if (!bundle) {
    return null;
  }
  if (!config.apiUrls?.apiweb) {
    throw new Error('Missing API URL');
  }

  return `${config.apiUrls.apiweb}image/bundle/${bundle.uuid}?v=${bundle.version}&w=t`;
};
